export default "__VITE_ASSET__9efcd984__"